import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-16" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-17" data-mp="pj6c83lngiqh">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-18" data-mp="avd0itzoq0d6">
          5 Exclusive Strategic Bonuses
        </h2>
        <p className="mt-2 text-center text-sm text-ink/60" data-id="element-19" data-mp="1uer1w6h90n7">
          Valued at{' '}
          <span className="font-bold text-amber-700 line-through" data-id="element-20" data-mp="1wrir121epdg">
            $148 USD
          </span>{' '}
          — Included <span className="font-bold text-brand" data-id="element-21" data-mp="3o1v48bynxmnk">FREE</span>
        </p>

        <ol className="mt-9 space-y-4" data-id="element-22" data-mp="3o3pu84osk4yi">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-4 rounded-2xl bg-white p-4 shadow-[0_1px_3px_rgba(20,17,15,0.06)]" data-id="element-23" data-mp="3t0yd67hrkd0t" data-mpi={index}>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand font-display text-sm font-bold text-white" data-id="element-24" data-mp="1r80e3txe8o7f">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-14 w-11 shrink-0 rounded object-cover" data-id="element-25" data-mp="3dea994tuhm9s" />
              <div data-id="element-26" data-mp="3n552wu9f7o59">
                <h3 className="font-display text-sm font-bold leading-snug text-ink" data-id="element-27" data-mp="3n4wlcp2crunq">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[11px] font-bold" data-id="element-28" data-mp="2zfu77r6xgjxz">
                  <span className="text-amber-700 line-through" data-id="element-29" data-mp="2uh967pjupw8h">
                    was {bonus.was}
                  </span>{' '}
                  <span className="text-brand" data-id="element-30" data-mp="38htngha4bjzv">FREE</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}